import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Card, Col, Form, Row, Space, Switch } from 'antd';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { IDriveIdConfigurationUpdate } from 'common/services/configuration-service/configuration.service.types';
import configurationService from 'common/services/configuration-service/configuration.service';
import configurationStore from 'common/stores/configuration/configuration.store';
import { notification } from 'common/utils/notification';
import './drive-id-configuration.scss';

const DriveIdConfiguration = observer(() => {
  const [form] = Form.useForm();

  const initData = configurationStore.configuration?.driveIdConfiguration;

  let timeoutId: any;

  const handleFormValuesChange = (changedValues: any, allValues: any) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      form.submit();
    }, 1500);
  };

  const onFinish = async (values: any) => {
    const model: IDriveIdConfigurationUpdate = {
      driveIdConfiguration: { isCaptureDriverName: values.isCaptureDriverName },
    };

    const result = await configurationService.updateSystemConfiguration(model);
    configurationStore.setConfiguration(result);
    notification.success({
      message: 'Configurations successfully updated',
      duration: 5,
    });
  };

  useEffect(() => {
    if (form) {
      form.setFieldsValue(initData);
    }
  }, [form, initData]);

  return (
    <FormWrapper form={form} onValuesChange={handleFormValuesChange} onFinish={onFinish} layout="vertical">
      <Card className="eiq-card eiq-card-border eiq-configuration">
        <Row className="eiq-card-header">
          <Col span={24}>
            <h1 className="h1">DriveID Settings</h1>
          </Col>
        </Row>
        <Col xs={24} sm={12}>
          <Space className="full-width drive-id-configuration-wrapper" size={13}>
            <div className="drive-id-configuration">
              <div>Entry Type “Passenger/Unlisted Vehicle” captures Driver First Name and Last Name.</div>
              <div className="description">
                When “Passenger/Unlisted Vehicle” is selected as Entry Type, the captured First Name and Last Name will populate the Driver
                First Name and Last Name fields.
              </div>
            </div>
            <Form.Item name="isCaptureDriverName" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Space>
        </Col>
      </Card>
    </FormWrapper>
  );
});

export default DriveIdConfiguration;
